// File: src/components/employees/employeeDefaults.ts
import { Employee } from "0.Mine/3.Interfaces/Employee";

// Default schedule template
export const defaultSchedule = {
  lunedi: {
    isOpen: true,
    isContinuous: false,
    morningOpen: "09:00",
    morningClose: "11:30",
    afternoonOpen: "14:30",
    afternoonClose: "19:00",
  },
  martedi: {
    isOpen: true,
    isContinuous: false,
    morningOpen: "09:00",
    morningClose: "11:30",
    afternoonOpen: "14:30",
    afternoonClose: "19:00",
  },
  mercoledi: {
    isOpen: true,
    isContinuous: false,
    morningOpen: "09:00",
    morningClose: "11:30",
    afternoonOpen: "14:30",
    afternoonClose: "19:00",
  },
  giovedi: {
    isOpen: true,
    isContinuous: false,
    morningOpen: "09:00",
    morningClose: "11:30",
    afternoonOpen: "14:30",
    afternoonClose: "19:00",
  },
  venerdi: {
    isOpen: true,
    isContinuous: false,
    morningOpen: "09:00",
    morningClose: "11:30",
    afternoonOpen: "14:30",
    afternoonClose: "19:00",
  },
  sabato: {
    isOpen: true,
    isContinuous: false,
    morningOpen: "09:00",
    morningClose: "11:30",
    afternoonOpen: "14:30",
    afternoonClose: "19:00",
  },
  domenica: {
    isOpen: false,
    isContinuous: false,
    morningOpen: "09:00",
    morningClose: "11:30",
    afternoonOpen: "14:30",
    afternoonClose: "19:00",
  },
};

// Default photo for new employees
export const defaultEmployeePhoto =
  "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80";
